import styled from "styled-components";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();
  const base = ["/", "/home", "/login", "/register"].includes(pathname) ? "" : "/";

  return (
    <Wrap>
      <Inner>
        <Brand>
          <strong>
            Vinayaka <span>Matrimony</span>
          </strong>
          <p>A social initiative of Vinayaka Foundation, Kannur.</p>
        </Brand>
        <Links aria-label="Footer">
          <a href="/register">Register free</a>
          <a href="/login">Log in</a>
          <a href={`${base}#about`}>About</a>
          <a href="/premium">Premium</a>
          <a href={`${base}#contact`}>Contact</a>
        </Links>
      </Inner>
      <Legal>© Copyright Vinayaka Matrimony. All Rights Reserved</Legal>
    </Wrap>
  );
};

const Wrap = styled.footer`
  margin-top: clamp(64px, 8vw, 96px);
  background: var(--navy);
  color: rgb(254 254 254 / 0.78);
  padding: 48px var(--gutter) calc(28px + env(safe-area-inset-bottom));
`;

const Inner = styled.div`
  max-width: var(--max-w);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid rgb(254 254 254 / 0.14);

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const Brand = styled.div`
  strong {
    font-family: var(--font-display);
    font-size: 24px;
    color: #fefefe;
    letter-spacing: -0.02em;
  }

  strong span {
    font-weight: 400;
  }

  p {
    margin: 6px 0 0;
    font-size: 15px;
  }
`;

const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 28px;

  a {
    color: #fefefe;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.2s ease;
  }

  a:hover {
    color: var(--butter);
  }
`;

const Legal = styled.p`
  max-width: var(--max-w);
  margin: 24px auto 0;
  font-size: 14px;
`;

export default Footer;
